"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromFP16 = exports.toFP16 = void 0;
// https://github.com/petamoriken/float16
const float16_1 = require("@petamoriken/float16");
const debugOverride = process.env.DEBUG_OVERRIDE === 'true';
const debug = (!process.env.AWS_SESSION_TOKEN && false) || debugOverride;
const toFP16 = (decimal) => {
    const buffer = new ArrayBuffer(2);
    const view = new DataView(buffer);
    (0, float16_1.setFloat16)(view, 0, decimal);
    debug && console.log('view.buffer', view.buffer);
    const msb = view.getUint8(0);
    const lsb = view.getUint8(1);
    const buf = Buffer.from([msb, lsb]);
    return buf;
};
exports.toFP16 = toFP16;
/**
 * @function fromFP16 twoByteFP16 is MSB LSB order
 * @param twoByteFP16
 * @returns
 */
const fromFP16 = (twoByteFP16, LE) => {
    const buffer = new ArrayBuffer(2);
    const view = new DataView(buffer);
    const msb = twoByteFP16[0];
    const lsb = twoByteFP16[1];
    view.setUint8(0, msb);
    view.setUint8(1, lsb);
    const res = (0, float16_1.getFloat16)(view, 0, LE);
    debug && console.log('view.buffer', view.buffer);
    return res;
};
exports.fromFP16 = fromFP16;
